import { forwardRef, type PropsWithChildren } from 'react'

import { SectionWrapper, Title } from './styled'

type Props = PropsWithChildren<{
  readonly title: string
}>

export const Section = forwardRef<HTMLDivElement, Props>(
  ({ title, children, ...props }, ref) => (
    <SectionWrapper {...props} ref={ref}>
      <Title layoutId={`layout-${title}`}>{title}</Title>
      {children}
    </SectionWrapper>
  )
)
